define.alias("shared/components/shared/loading-cards", "media/components/shared/loading-cards");